import { render, staticRenderFns } from "./reviewerRank.vue?vue&type=template&id=80003ea6&scoped=true&"
import script from "./reviewerRank.vue?vue&type=script&lang=js&"
export * from "./reviewerRank.vue?vue&type=script&lang=js&"
import style0 from "./reviewerRank.vue?vue&type=style&index=0&id=80003ea6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80003ea6",
  null
  
)

export default component.exports